import { useEffect } from 'react';
import type { ArticleDetail } from '@/mocks/article';

interface ArticleSchemaProps {
  article: ArticleDetail;
}

export default function ArticleSchema({ article }: ArticleSchemaProps) {
  useEffect(() => {
    const schemas = [
      {
        '@context': 'https://schema.org',
        '@type': 'Article',
        headline: article.title,
        description: article.description,
        author: {
          '@type': 'Person',
          name: article.author,
        },
        datePublished: '2026-01-15',
        dateModified: article.updateTime,
        publisher: {
          '@type': 'Organization',
          name: '51漫画网',
          url: 'https://51manhua.com/',
        },
        mainEntityOfPage: {
          '@type': 'WebPage',
          '@id': `https://51manhua.com/article/${article.id}`,
        },
      },
      {
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: [
          {
            '@type': 'ListItem',
            position: 1,
            name: '首页',
            item: 'https://51manhua.com/',
          },
          {
            '@type': 'ListItem',
            position: 2,
            name: article.category,
            item: `https://51manhua.com/category/${article.categorySlug}`,
          },
          {
            '@type': 'ListItem',
            position: 3,
            name: article.title,
          },
        ],
      },
      {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: [
          {
            '@type': 'Question',
            name: '什么是下拉式漫画阅读？',
            acceptedAnswer: {
              '@type': 'Answer',
              text: '下拉式阅读是一种创新的漫画浏览方式，您无需翻页，只需向下滚动即可连续阅读漫画内容。51漫画网的所有漫画均支持下拉式阅读。',
            },
          },
          {
            '@type': 'Question',
            name: '51漫画网的漫画是否有删减？',
            acceptedAnswer: {
              '@type': 'Answer',
              text: '51漫画网承诺所有漫画内容均为无删减版本，我们致力于为读者提供最完整、最原汁原味的韩漫阅读体验。',
            },
          },
          {
            '@type': 'Question',
            name: '如何找到我想看的漫画？',
            acceptedAnswer: {
              '@type': 'Answer',
              text: '您可以通过首页的分类浏览找到感兴趣的题材，也可以在搜索框中输入漫画名称或作者名进行查找。',
            },
          },
          {
            '@type': 'Question',
            name: '漫画更新频率是怎样的？',
            acceptedAnswer: {
              '@type': 'Answer',
              text: '51漫画网与韩国更新保持同步，大部分连载漫画每周更新1-2话。您还可以通过邮箱订阅功能第一时间收到更新通知。',
            },
          },
        ],
      },
    ];

    const scriptId = 'schema-org-article';
    const existing = document.getElementById(scriptId);
    if (existing) existing.remove();

    const script = document.createElement('script');
    script.id = scriptId;
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(schemas, null, 2);
    document.head.appendChild(script);

    return () => {
      const el = document.getElementById(scriptId);
      if (el) el.remove();
    };
  }, [article]);

  return null;
}